import React from 'react';
import './loading.scss';

const Loading = () => <div className = "preloader" />
export default Loading;